import { COLORS } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (): IStyles => {
  return {
    root: {
      mt: 2,
      width: '100%',
    },

    label: {
      color: COLORS.WHITE,
      position: 'relative',
      border: 'none',
      width: '100% !important',
      textAlign: 'left',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: '0.02em',
      transform: 'unset',

      '&.Mui-focused': {
        color: COLORS.WHITE,
      },
    },

    select: {
      flexDirection: 'row-reverse',
      width: '100%',
      height: 32,
      color: COLORS.WHITE,

      '& .MuiInput-input': {
        pl: 1,
        letterSpacing: '-0.04em',
      },

      '&.Mui-disabled': {
        color: COLORS.WHITE,
        cursor: 'no-drop',
      },
      '& .MuiInput-input.Mui-disabled': {
        cursor: 'no-drop',
        WebkitTextFillColor: 'unset',
      },

      '&.MuiInputBase-formControl': {
        mt: 1,
        backgroundColor: '#03030366',
        borderRadius: 1,
      },

      '.MuiSelect-select': {
        pr: '32px !important',
        width: 320,
        boxSizing: 'border-box',
        borderRadius: 1,
      },

      '& svg': {
        color: COLORS.WHITE,
        right: 6,
      },
      '& .selectIcon': {
        ml: 1,
        opacity: 0.5,
        color: COLORS.AZURE,
      },
    },
  };
};
